/**
 * Conviventie Label Helpers
 *
 * Single source of truth for how an invited gemeenschap is labelled in the UI:
 * "Parochie - Gemeenschap", so the same qualifier is used in the Uitgenodigde
 * list, the invitation editor and the Leden page selectors.
 */

/**
 * Formats a gemeenschap as "Parochie - Gemeenschap".
 *
 * Accepts both an invited entry (which snapshots `gemeenschapNaam`/`parochie`)
 * and a gemeenschappen document (which stores `gemeenschap`/`parochie`). Missing
 * parts degrade gracefully, so legacy entries without a snapshot still render.
 *
 * @param {Object|null|undefined} item
 * @returns {string}
 */
export const formatGemeenschapLabel = (item) => {
  const naam = String(item?.gemeenschapNaam || item?.gemeenschap || '').trim();
  const parochie = String(item?.parochie || '').trim();

  if (naam && parochie) {
    return `${parochie} - ${naam}`;
  }

  return naam || parochie || '-';
};

/**
 * Formats the full entity definition "Bisdom - Parochie - Gemeenschap".
 *
 * Same part ordering as the confirmation notification's `gemeenschapPad`
 * (`conviventieService.js`), so a gemeenschap reads identically everywhere it is
 * printed outside the UI — e.g. in download file names. Missing parts are
 * dropped instead of rendered as "Onbekend", so a legacy invitation snapshot
 * without bisdom still produces a usable label.
 *
 * @param {Object|null|undefined} item
 * @returns {string}
 */
export const formatGemeenschapFullLabel = (item) => {
  const parts = [
    String(item?.bisdom || '').trim(),
    String(item?.parochie || '').trim(),
    String(item?.gemeenschapNaam || item?.gemeenschap || '').trim()
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(' - ') : '-';
};